
export default [
  {
    path: '/dashboard',
    component:  (resolve) => require(['../components/pages/HomePage'], resolve),
    children: [
      {path: '', component:(resolve) => require(['../components/pages/appointment/Statistics'], resolve)},
      {path: 'statistics', name:'statistics', component:(resolve) => require(['../components/pages/appointment/Statistics'], resolve)},
      {path: 'calendar', name:'calendar', component:(resolve) => require(['../components/pages/schedulingcalendar/Calendar'], resolve),
        children: [
          {path: '',  component:(resolve) => require(['../components/pages/schedulingcalendar/YearCalendar'], resolve)},
          {path: 'yearcalendar', name: 'yearcalendar', component:(resolve) => require(['../components/pages/schedulingcalendar/YearCalendar'], resolve)},
          {path: 'monthcalendar', name: 'monthcalendar', component:(resolve) => require(['../components/pages/schedulingcalendar/MonthCalendar'], resolve)},
        ]
      },
      {path: 'setindex', name:'setindex', component:(resolve) => require(['../components/pages/personnelset/SetIndex'], resolve)},
      // {path: 'appointmentset', name:'appointmentset', component:(resolve) => require(['../components/pages/appointmentset/AppointmentSet'], resolve)},
      // {path: 'departmentset', name:'departmentset', component:(resolve) => require(['../components/pages/DepartmentSet/departmentset'], resolve)},
      {path: 'deptset', name:'deptset', component:(resolve) => require(['../components/pages/DepartmentSet/deptset'], resolve),
        children: [
          {path: '',  component:(resolve) => require(['../components/pages/DepartmentSet/department'], resolve)},
          {path: 'department', name: 'department', component:(resolve) => require(['../components/pages/DepartmentSet/department'], resolve)},
          {path: 'post', name: 'post', component:(resolve) => require(['../components/pages/DepartmentSet/post'], resolve)},
        ]
      },
      {path: 'roomset', name:'roomset', component:(resolve) => require(['../components/pages/meetingroom/RoomSet'], resolve)},
      {path: 'user', name:'user', component:(resolve) => require(['../components/pages/appointmentuser/User'], resolve)},
    ],
    meta:{
      auth:true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboardRoute.js